import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export const store = new Vuex.Store({
  state: {
    user: {},
    token: "",
  },
  mutations: {
    updateUser: (state, payload) => {
      state.user = payload;
    },
    updateUserToken: (state, payload) => {
      state.token = payload;
    },
    updateSchool: (state, payload) => {
      state.school = payload;
    },
  },
  actions: {
    updateUser: (context, payload) => {
      context.commit("updateUser", payload);
    },
    updateUserToken: (context, payload) => {
      context.commit("updateUserToken", payload);
    },
    updateSchool: (context, payload) => {
      context.commit("updateSchool", payload);
    },
  },
  plugins: [createPersistedState()],
});
